/**
 * Access to the Project Details hub (`/projects/:id`).
 *
 * The route must not depend solely on the `projects.details` eye toggle.
 * Role Page defaults missing details children to off, so deployed Admin
 * roles often have parent `projects` view on and details explicitly denied —
 * which blocked Agent Studio's project-name crumb.
 *
 * Allow: parent Projects view, details eye, tenant Admin, or platform admin.
 * GET /api/projects/{id} still enforces owner / member / admin membership.
 */

import { isEffectiveAdmin } from '@utils/rbacHelpers'

export interface ProjectDetailsAccessInput {
  canViewUI: (feature: string, subFeature?: string) => boolean
  isPlatformAdmin: boolean
  currentUser: { roles?: Array<{ name: string }>; is_platform_admin?: boolean } | null
}

export function canEnterProjectDetailsPage(input: ProjectDetailsAccessInput): boolean {
  if (isEffectiveAdmin(input.currentUser, input.isPlatformAdmin)) return true
  if (input.canViewUI('projects', 'details')) return true
  return input.canViewUI('projects')
}

/** Missing Role Page rows for the details hub inherit parent Projects eye. */
export function inheritProjectsDetailsEye(
  subKey: string,
  parentTab: string | undefined,
  parentEye: boolean,
): boolean {
  return subKey === 'details' || parentTab === 'details' ? parentEye : false
}
